import { render } from "./App.vue?vue&type=template&id=421b5b40&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=421b5b40&lang=scss"

import exportComponent from "C:\\Users\\owner\\Documents\\projects\\stakingapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__